import { useDispatch } from "react-redux";
import {
  storeCoreUiSelectAsideShow,
  storeCoreUiSelectSidebarShow,
  storeCoreUiSetLayout,
} from "../datasources/_coreui.layout.store.slice";
import { useCoreUiTypedSelector } from "../../../configs/_coreui.store.slice";

export const useCoreUiHeaderController = () => {
  const dispatch = useDispatch();
  const sidebarShow = useCoreUiTypedSelector(storeCoreUiSelectSidebarShow);
  const asideShow = useCoreUiTypedSelector(storeCoreUiSelectAsideShow);

  const setSidebarShow = (sidebarShow: boolean) => {
    dispatch(storeCoreUiSetLayout({ sidebarShow: sidebarShow }));
  };

  const setAsideShow = (asideShow: boolean) => {
    dispatch(storeCoreUiSetLayout({ asideShow: asideShow }));
  };

  return {
    state: {
      sidebarShow,
      asideShow,
    },
    action: {
      setSidebarShow,
      setAsideShow,
    },
  };
};
